import React from 'react';

const Card = ({children, onClick, ...rest}) => (
    <a className="main-card" onClick={onClick} {...rest}>
{children}
    <span className="main-card-active-bar"></span>
    </a>
);

export default Card;